import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=5828890c&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=5828890c&prod&lang=scss&scoped=true"
import style1 from "./SingleOrder.vue?vue&type=style&index=1&id=5828890c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828890c",
  null
  
)

export default component.exports